import { Box } from "@mantine/core";
import { FC } from "react";

import avatar from "@/assets/images/pngs/javis-ai-avatar.png";

/**
 * Avatar robot của Javis AI — bộ nhận diện 24/08/2026.
 *
 * Trước đây vẽ tay bằng SVG nội tuyến vì `assets/` chưa có icon AI nào. Nay đã có file chính thức
 * nên dùng thẳng: ảnh gốc 64×64, chỗ dùng lớn nhất là 28px (56px trên màn hình 2x) — tức luôn
 * THU NHỎ, không phóng to, nên không vỡ.
 *
 * `variant="white"`: nút "Chat với Javis AI" ở thanh header nằm trên nền xanh #2A81D0, mà avatar
 * mới chính là màu xanh đó — đặt trần lên sẽ chìm. Nên lót một đĩa trắng phía sau thay vì đổi màu
 * ảnh (tô trắng toàn bộ sẽ mất mũ, mặt và dấu cộng, chỉ còn một khối bệt).
 */
const BotAvatar: FC<{ size?: number; variant?: "color" | "white" }> = ({
  size = 28,
  variant = "color",
}) => {
  const onDisc = variant === "white";
  // Đĩa trắng lớn hơn ảnh một chút để ảnh không chạm mép.
  const pad = onDisc ? Math.round(size * 0.12) : 0;

  return (
    <Box
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        background: onDisc ? "#FFFFFF" : "transparent",
      }}
    >
      <img
        src={avatar}
        alt=""
        aria-hidden="true"
        width={size - pad * 2}
        height={size - pad * 2}
        style={{ display: "block" }}
      />
    </Box>
  );
};

export default BotAvatar;
